import React from 'react';

import { TextWithDictionarySelector } from '../../../app/components/TextWithDictionarySelector';

const DICTIONARY_TYPE = 'Pozycje faktur';

interface SalesInvoicePositionNameSelectorProps {
  value?: string;
  onChange: (value: string) => void;
  readOnly?: boolean;
}

export const SalesInvoicePositionNameSelector: React.FC<
  SalesInvoicePositionNameSelectorProps
> = ({ value, onChange, readOnly }) => (
  <TextWithDictionarySelector
    value={value}
    onChange={onChange}
    dictionaryType={DICTIONARY_TYPE}
    readOnly={readOnly}
  />
);
